import { privateOfficeService } from "@/services/private-office-service";
import { LoaderFunctionArgs } from "react-router-dom";

export async function updateHistoryLoader({ params }: LoaderFunctionArgs) {
  if (!params.roomId) throw new Error("Room ID is required");
  const data = await privateOfficeService.getUpdateHistory(params.roomId);
  return { history: data, isLoading: false };
}
